import { sweetAlert } from "src/app/utils/swal";
import { Component, OnInit, OnDestroy, ElementRef, ViewChild } from "@angular/core";
import { componentDestroyed } from "@w11k/ngx-componentdestroyed";
import { takeUntil } from "rxjs/operators";
import { Router } from "@angular/router";
import { ParserService } from "../planner-service/parser-service";
import { SharedDataService } from "src/app/service/shared-service/shared-data.service";
import { BrokerDropdownService } from "../../shared/broker-dropdown/broker-dropdown.service";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import * as moment from "moment";

@Component({
  selector: "app-parse-trips",
  templateUrl: "./parse-trips.component.html",
  styleUrls: ["./parse-trips.component.css"],
})

export class ParseTripsComponent implements OnInit, OnDestroy {
  @ViewChild('fileInput', { static: false }) fileInput!: ElementRef;
  selectedFile = null;
  submitted = false;
  isDissable = false;
  corporateBrokers = [];
  preCorporateBrokers = {};
  selectedCorporate;
  invalidFileType = false;
  isTripsLoading = false;
  todayDate;
  parseTripFrom: UntypedFormGroup;

  constructor(
    private fb: UntypedFormBuilder,
    private brokerService: BrokerDropdownService,
    private parserService: ParserService,
    private sharedDataService: SharedDataService,
    private router: Router) { }

  ngOnInit() {

    this.parseTripFrom = this.fb.group({
      cooperate: ["", Validators.required],
      companyType: ["", Validators.required],
      isFile: ["", Validators.required],
      providerTripId: [""],
    })

    this.getUser();

  }

  getUser() {
    this.sharedDataService
      .getUser()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.todayDate = moment.tz(data.timeZone).startOf('day').toISOString();
          this.getBrokersList();
        }
      });
  }

  get form() {
    return this.parseTripFrom.controls;
  }

  getBrokersList() {
    this.brokerService.getCorporateBrokers().subscribe(data => {
      if (data) {
        this.corporateBrokers = data;
        this.preCorporateBrokers = this.corporateBrokers.reduce((obj, item) => (obj[item._id] = item, obj), {});

      }
    })
  }

  submitFile() {
    this.submitted = true;
    if (!this.parseTripFrom.value.cooperate || this.isDissable) {
      return;
    }
    this.isDissable = true;
    const selectedCorporate = this.parseTripFrom.get('cooperate').value;
    this.parseTripFrom.patchValue({
      companyType: this.preCorporateBrokers[selectedCorporate].companyType,
      isFile: this.selectedFile ? true : false,
    })

    const data = this.parseTripFrom.value;

    if (this.selectedFile) {
      if (
        this.selectedFile.type === "application/vnd.ms-excel" ||
        this.selectedFile.type ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
        this.selectedFile.type === "text/csv"
      ) {
        this.scrapTrips(this.selectedFile, data);
      } else {
        this.invalidFileType = true;
        this.isDissable = false;
        this.selectedFile = null;
        this.fileInput.nativeElement.value = '';
      }
    }

  }

  readURL(event): void {
    if (event.target && event.target.files && event.target.files[0]) {
      this.selectedFile = event.target.files[0];
    }
  }

  scrapTrips(file, payload) {
    this.parserService
      .scrapTrips(file, payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.router.navigateByUrl("/trips");
        } else {
          this.isDissable = false;
          this.fileInput.nativeElement.value = '';
          this.selectedFile = null;
            sweetAlert("Error", 'Operation failed', "error", "Ok");
        }
      }, err => {
        this.isDissable = false;
        this.fileInput.nativeElement.value = '';
        this.selectedFile = null;
        if (typeof err  === 'string') {
          sweetAlert("Error", err, "error", "Ok");
        } else {
          sweetAlert("Error", 'Operation failed', "error", "Ok");
        }
      });
  }

  onCorporateChange(evt) {
    if (evt) {
      this.selectedCorporate = this.preCorporateBrokers[evt];
    } else {
      this.selectedCorporate = null;
    }
  }

  onDateChange(event) {
    this.todayDate = event;
  }

  fetchTrips() {
   sweetAlert('Alert', `Are you sure you want to fetch ${this.selectedCorporate.displayName} trips?`, 'warning', 'Yes', 'No')
      .then((result: any) => {
        if (result.value) {
          this.isTripsLoading = true;
          if (this.selectedCorporate.companyType === 'callthecar') {
            this.fetchCTCTrips();
          } else if (this.selectedCorporate.companyType === 'first'){
            this.fetchMTMTrips();
          } else {
            this.fetchKaiserTrips();
          }
        }
      });
  }

  fetchKaiserTrips() {

    const selectedCorporate = this.parseTripFrom.get('cooperate').value;
    const payload = {cooperate: this.preCorporateBrokers[selectedCorporate], dos: moment(this.todayDate).format('YYYY-MM-DD') }

    this.parserService.getKaiserTrips(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        this.isTripsLoading = false;
        if (data) {
          if (data.total > 0) {
            sweetAlert('Success', `${data.total} Trips Fetched Successfully`, 'success', 'OK')
              .then((result: any) => {
                if (result.value) {
                  this.router.navigateByUrl('trips');
                }
              });
          }
          else {
            sweetAlert('Alert', `${data.total} Trip Fetched`, 'warning', 'OK')
          }
        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
        this.isTripsLoading = false;
      });
  }



  fetchCTCTrips() {
    const selectedCorporate = this.parseTripFrom.get('cooperate').value;
    const payload = {cooperate: this.preCorporateBrokers[selectedCorporate], dos: moment(this.todayDate).format('YYYY-MM-DD') }

    this.parserService.fetchCTCTrips(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        this.isTripsLoading = false;
        if (data) {
          if (data.total > 0) {
            sweetAlert('Success', `${data.total} Trips Fetched Successfully`, 'success', 'OK')
              .then((result: any) => {
                if (result.value) {
                  this.router.navigateByUrl('trips');
                }
              });
          }
          else {
            sweetAlert('Alert', `${data.total} Trip Fetched`, 'warning', 'OK')
          }
        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
        this.isTripsLoading = false;
      });
  }


  fetchMTMTrips() {

    const selectedCorporate = this.parseTripFrom.get('cooperate').value;
    const providerTripId = this.parseTripFrom.get('providerTripId').value;
    const payload = {cooperate: this.preCorporateBrokers[selectedCorporate], providerTripId, dos: moment(this.todayDate).format('YYYY-MM-DD') }

    this.parserService.fetchMTMTrips(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        this.isTripsLoading = false;
        if (data) {
          if (data.total > 0) {
            sweetAlert('Success', `${data.total} Trips Fetched Successfully`, 'success', 'OK')
              .then((result: any) => {
                if (result.value) {
                  this.router.navigateByUrl('trips');
                }
              });
          }
          else {
            sweetAlert('Alert', `${data.total} Trip Fetched`, 'warning', 'OK')
          }
        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
        this.isTripsLoading = false;
      });
  }


  ngOnDestroy(): void { }
}
